import { render, staticRenderFns } from "./SingleClientCaptureSignature.vue?vue&type=template&id=04a2553c&"
import script from "./SingleClientCaptureSignature.vue?vue&type=script&lang=js&"
export * from "./SingleClientCaptureSignature.vue?vue&type=script&lang=js&"
import style0 from "./SingleClientCaptureSignature.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports